module.exports = __webpack_public_path__ + "static/media/image.846baa50.svg";